// Generated by CoffeeScript 2.7.0
var IMAGE_MIME_TYPES, Utilities, checkBrowser, generateDataKey, generateElement, getOrCreateCleaningElementByIdForVue, getOrCreateElementById, getOrCreateElementByIdForVue, goTo, gracefullyBackTo, gracefullyGoTo, hardGoTo, hysteresis, hysteresisTimers, join, parseFile, stringifyFilter, uuid, uuidCounter, watermarkImage, watermarkMime;

uuidCounter = 0;

hysteresisTimers = {};

goTo = function(uri) {
  return Turbolinks.visit(uri);
};

hardGoTo = function(uri) {
  return window.location = uri;
};

// https://github.com/rails/turbolinks/blob/2-5-stable/lib%2Fassets%2Fjavascripts%2Fturbolinks.js.coffee#L158
gracefullyGoTo = function(url, title = '', options = {}) {
  if (Turbolinks.supported) {
    if (title !== false) {
      document.title = title;
    }
    return window.history.replaceState(options, title, url);
  } else {
    return Turbolinks.visit(url);
  }
};

gracefullyBackTo = function(url, title = '', options = {}) {
  if (Turbolinks.supported) {
    if (title !== false) {
      document.title = title;
    }
    return window.history.replaceState(options, title, url);
  } else {
    return Turbolinks.visit(url);
  }
};

generateElement = function(tagName, options = {}) {
  var element, key, value;
  if (typeof tagName !== 'string') {
    options = tagName;
    tagName = options.tagName;
  }
  delete options.tagName;
  element = document.createElement(tagName);
  for (key in options) {
    value = options[key];
    element[key] = value;
  }
  return element;
};

getOrCreateElementById = function(id_selector, parent = document.body, attrs = {}) {
  var el;
  if (!(el = document.getElementById(id_selector))) {
    el = generateElement('div', attrs);
    el.id = id_selector;
    el.data('generated-by-api', true);
    parent.appendChild(el);
  }
  return el;
};

getOrCreateElementByIdForVue = function(id_selector, parent = document.body, attrs = {}) {
  var el, vue_mounted_el;
  if (!(el = document.getElementById(id_selector))) {
    el = generateElement('div', attrs);
    el.id = id_selector;
    el.data('generated-by-vue', true);
    parent.appendChild(el);
  }
  vue_mounted_el = generateElement('div');
  el.appendChild(vue_mounted_el);
  return vue_mounted_el;
};

getOrCreateCleaningElementByIdForVue = function(id_selector, parent = document.body, attrs = {}) {
  var element;
  element = getOrCreateElementByIdForVue.apply(null, arguments);
  parent = element.parentElement;
  parent.innerHTML = '';
  parent.appendChild(element);
  return element;
};

generateDataKey = function(attr_name) {
  return attr_name && attr_name.replace('_', '-');
};

join = function(ary, sep) {
  if (ary.length === 0) {
    return [];
  } else {
    return _.reduce(ary.slice(1), function(result, item) {
      return result.concat([sep, item]);
    }, [ary[0]]);
  }
};

uuid = function() {
  var _now;
  _now = _.now();
  uuidCounter = uuidCounter === _now ? uuidCounter + 1 : Math.max(_now, uuidCounter) + 1;
  return uuidCounter;
};

hysteresis = function(fn, uid, delay = 1000) {
  if (hysteresisTimers[uid]) {
    clearTimeout(hysteresisTimers[uid]);
    delete hysteresisTimers[uid];
  }
  return hysteresisTimers[uid] = setTimeout(function() {
    fn();
    return delete hysteresisTimers[uid];
  }, delay);
};

stringifyFilter = function(string) {
  if (!string) {
    return;
  }
  return string.replace(/([\+|\-]?)(\d{1,2})([d|w|m])(\-?\d{0,2})/, function($0, $1, $2, $3, $4) {
    var addition, dimension, need_short, period, timespan, w_list;
    need_short = $2 === '1';
    period = (function() {
      switch ($1) {
        case '+':
          if (need_short) {
            if ($3 === 'd') {
              return '明';
            } else {
              return '下';
            }
          } else {
            return '未来';
          }
          break;
        case '-':
          if (need_short) {
            if ($3 === 'd') {
              return '昨';
            } else {
              return '上';
            }
          } else {
            return '过去';
          }
          break;
        default:
          if (need_short) {
            if ($3 === 'd') {
              return '今';
            } else {
              return '本';
            }
          } else {
            return '当前';
          }
      }
    })();
    timespan = need_short ? '' : $2;
    dimension = (function() {
      switch ($3) {
        case 'd':
          return '天';
        case 'w':
          return '周';
        case 'm':
          return '月';
      }
    })();
    addition = (function() {
      if ($4) {
        switch ($3) {
          case 'w':
            w_list = ['一', '二', '三', '四', '五', '六', '日'];
            return '星期' + w_list[$4 - 1];
          case 'm':
            if ($4 === '-1') {
              return '最后1日';
            } else {
              return $4 + '日';
            }
            break;
          default:
            return '';
        }
      } else {
        return '';
      }
    })();
    return period + timespan + dimension + addition;
  });
};

checkBrowser = function(param) {
  var UA, inBrowser;
  inBrowser = typeof window !== 'undefined';
  UA = inBrowser && window.navigator.userAgent.toLowerCase();
  if (param === 'IOS') {
    return UA && /iphone|ipad|ipod|ios/.test(UA);
  } else {
    return UA && UA.indexOf(param) > 0;
  }
};

// Only used to pick a canvas.toBlob output type. Storage MIME types are decided
// server-side — do not grow this into a general extension table.
IMAGE_MIME_TYPES = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp'
};

watermarkMime = function(file) {
  var ext, type;
  type = (file && file.type) || '';
  if (type.indexOf('image/') === 0) {
    return type;
  }
  ext = String((file && file.name) || '').split('.').pop().toLowerCase();
  return IMAGE_MIME_TYPES[ext] || 'image/png';
};

parseFile = function(dataUrl, {type, name}) {
  var blob, bstr, file, length, u8arr;
  bstr = atob(dataUrl.split(',')[1]);
  length = bstr.length;
  u8arr = new Uint8Array(length);
  while (length--) {
    u8arr[length] = bstr.charCodeAt(length);
  }
  blob = new Blob([u8arr], {type, name});
  file = new File([blob], name, { type: type || blob.type || '' });
  return file;
};

watermarkImage = function(file, {location_watermark, datetime_watermark}) {
  return new Promise((resolve) => {
    var reader;
    reader = new FileReader();
    reader.readAsDataURL(file);
    return reader.onload = (e) => {
      var img;
      img = document.createElement('img');
      img.src = reader.result;
      return img.onload = () => {
        var DATETIME_WATERMARK_BOTTOM_MARGIN, DATETIME_WATERMARK_FONT_SIZE, LOCATION_WATERMARK_BOTTOM_MARGIN, LOCATION_WATERMARK_FONT_SIZE, canvas, ctx, dataUrl, date, devicePixelRatio, img_ratio, max_width, mime, newFile;
        mime = watermarkMime(file);
        max_width = document.body.clientWidth;
        // 图片最大宽度为屏幕宽度，保证水印字体大小一致
        if (img.width > max_width) {
          img_ratio = img.width / img.height;
          img.width = max_width;
          img.height = max_width / img_ratio;
        }
        canvas = document.createElement('canvas');
        ctx = canvas.getContext('2d');
        // devicePixelRatio 属性表示了屏幕的设备像素比，即用几个像素点宽度来渲染1个像素。
        // 使用 devicePixelRatio 放大 canvas 防止图片压缩模糊
        devicePixelRatio = window.devicePixelRatio;
        canvas.width = img.width * devicePixelRatio;
        canvas.height = img.height * devicePixelRatio;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.fillStyle = 'white';
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.shadowColor = 'rgba(0, 0, 0, 0.88)';
        ctx.shadowBlur = 1;
        ctx.lineWidth = 1;
        if (datetime_watermark) {
          DATETIME_WATERMARK_BOTTOM_MARGIN = 35;
          DATETIME_WATERMARK_FONT_SIZE = 24;
          date = new Date();
          ctx.font = `${DATETIME_WATERMARK_FONT_SIZE * devicePixelRatio}px PingFang SC`;
          ctx.strokeText(date.strftime('YYYY-MM-DD hh:mm'), canvas.width / 2, canvas.height - DATETIME_WATERMARK_BOTTOM_MARGIN * devicePixelRatio);
          ctx.fillText(date.strftime('YYYY-MM-DD hh:mm'), canvas.width / 2, canvas.height - DATETIME_WATERMARK_BOTTOM_MARGIN * devicePixelRatio);
        }
        if (location_watermark) {
          LOCATION_WATERMARK_BOTTOM_MARGIN = 16;
          LOCATION_WATERMARK_FONT_SIZE = 12;
          return Skylark.Libs.Geolocation.GetCurrentLocation((error, geoLocation) => {
            if (geoLocation) {
              return geoLocation.getRegeocode((_error, regeocode) => {
                var dataUrl, newFile;
                ctx.font = `${LOCATION_WATERMARK_FONT_SIZE * devicePixelRatio}px PingFang SC`;
                ctx.strokeText(`📍${regeocode.formattedAddress}`, canvas.width / 2, canvas.height - LOCATION_WATERMARK_BOTTOM_MARGIN * devicePixelRatio);
                ctx.fillText(`📍${regeocode.formattedAddress}`, canvas.width / 2, canvas.height - LOCATION_WATERMARK_BOTTOM_MARGIN * devicePixelRatio);
                dataUrl = canvas.toDataURL(mime);
                newFile = parseFile(dataUrl, {
                  type: mime,
                  name: file.name
                });
                return resolve(newFile);
              });
            } else {
              return resolve(file);
            }
          });
        } else {
          dataUrl = canvas.toDataURL(mime);
          newFile = parseFile(dataUrl, {
            type: mime,
            name: file.name
          });
          return resolve(newFile);
        }
      };
    };
  });
};

export default Utilities = {goTo, hardGoTo, gracefullyGoTo, gracefullyBackTo, generateElement, getOrCreateElementById, getOrCreateElementByIdForVue, getOrCreateCleaningElementByIdForVue, generateDataKey, join, uuid, hysteresis, stringifyFilter, checkBrowser, watermarkMime, parseFile, watermarkImage};
